import { getOnlyElementByAttribute } from './getOnlyElementByAttribute';
import { simulateClick } from './simulateClick';
import { upsellElements } from './upsellElements';

export const setCheckoutUpsellErrorStateObserver = () => {
  try {
    const errorStateObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function () {
        const { closeUpsellArray } = upsellElements();
        const closeUpsell = closeUpsellArray[0];
        simulateClick(closeUpsell);

        const placeOrderButtonClone = getOnlyElementByAttribute(
          '[data-fp="place-order-button-clone"]'
        ) as HTMLElement;

        placeOrderButtonClone.setAttribute(
          'data-node-type',
          'commerce-checkout-place-order-button'
        );
        errorStateObserver.disconnect();
      });
    });

    return { errorStateObserver };
  } catch (error) {
    throw error;
  }
};
